import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "31",
  height: "34",
  fill: "none",
  viewBox: "0 0 31 34"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-miterlimit": "10",
      "stroke-width": "4",
      d: "M15.5 17.517c4.302 0 7.79-3.473 7.79-7.758S19.801 2 15.5 2c-4.3 0-7.788 3.474-7.788 7.759s3.487 7.758 7.789 7.758Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "4",
      d: "M2 30.965c0-6.853 6.23-12.93 13.5-12.93S29 24.111 29 30.964V32H2v-1.035Z"
    }, null, -1)
  ])))
}
export default { render: render }